import FingoMuiInputLabel from '../../fingo/components/MuiInputLabel';

const MuiInputLabel = {
  styleOverrides: {
    root: ({ theme }) => ({
      ...FingoMuiInputLabel.styleOverrides.root({ theme }),
      '&.Mui-focused': {
        color: theme.palette.text.highlight,
        '& .MuiInputLabel-asterisk': {
          color: theme.palette.text.highlight,
        },
      },
    }),
    asterisk: ({ theme }) => ({
      ...FingoMuiInputLabel.styleOverrides.asterisk({ theme }),
    }),
  },
};

export default MuiInputLabel;
